import React from 'react';
import {useController} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

import {ImagePicker, TProps} from './ImagePicker';
import {EImagePickerError, TImagePickerResult} from './definitions';

const ImagePickerField = React.memo<TProps & {name: string}>(
  ({name, isInvalid, readOnly, error, value, onBlur, onError, onChange, ...props}) => {
    const {t} = useTranslation();

    const {
      field,
      fieldState: {error: fieldError},
    } = useController({name});

    const handleBlur = () => {
      field.onBlur();
      onBlur?.();
    };

    const handleError = (imageError: EImagePickerError[]) => {
      field.onChange(null);
      onError?.(imageError);
    };

    const handleChange = async (result: TImagePickerResult[]) => {
      await onChange?.(result);
      field.onBlur();
    };

    const isFieldInvalid = !readOnly && (!!fieldError || isInvalid);
    const fieldErrorMessage = isFieldInvalid
      ? t(fieldError?.message ?? '', fieldError?.ref?.value)
      : undefined;

    return (
      <ImagePicker
        {...props}
        readOnly={readOnly}
        name={name}
        value={value ?? field.value}
        error={error ?? fieldErrorMessage}
        isInvalid={isInvalid ?? isFieldInvalid}
        onBlur={handleBlur}
        onError={handleError}
        onChange={handleChange}
      />
    );
  },
);

export {ImagePickerField};
